import {
  ButtonBlock,
  ContentBlock,
  Font,
  List,
} from '@politechdev/blocks-design-system'
import { Timestamp } from 'components/Time/Timestamp'
import humanizeString from 'humanize-string'
import { AssociatedShift } from 'performanceReviews/types'
import { PropsWithChildren } from 'react'

const ShiftListItem = ({
  shift,
  children,
}: PropsWithChildren<{
  shift: AssociatedShift
}>) => (
  <List.Item>
    <ContentBlock>
      <Font.Copy>{shift.name}</Font.Copy>
      <Font.Copy variant="hint">
        {!!shift.ready_for_qc_at && (
          <Timestamp dateTime={shift.ready_for_qc_at} />
        )}
      </Font.Copy>
    </ContentBlock>
    <ContentBlock>
      <Font.Copy>{humanizeString(shift.status)}</Font.Copy>
      <Font.Copy variant="hint">{shift.location.name}</Font.Copy>
    </ContentBlock>
    <ButtonBlock justify="right">{children}</ButtonBlock>
  </List.Item>
)

export default ShiftListItem
